import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { LanguageService } from '../services/language.service';
import { AuthService } from '../services/auth/auth.service';
import { isTokenExpired } from '../shared/jwt';

export const registrationCompletionGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const languageService = inject(LanguageService);
  const locale = languageService.locale();

  const token = route.paramMap.get('token');

  if (!token) {
    return router.createUrlTree(['/', locale, 'error']);
  }

  if (isTokenExpired(token)) {
    return router.createUrlTree(['/', locale, 'expired-confirmation', token]);
  }

  try {
    await authService.completeRegistration(token);
    return router.createUrlTree(['/', locale, 'login'], {
      queryParams: { registrationSuccess: 'true' },
    });
  } catch (error) {
    return router.createUrlTree(['/', locale, 'error']);
  }
};
